var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.927,
    height: 30.235,
    viewBox: "0 0 31.927 30.235",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(4.625 -5.567) rotate(20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_104",
    "data-name": "Rettangolo 104",
    width: 24.853,
    height: 29.939,
    transform: "translate(8.497 33.944) rotate(-110)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_105",
    "data-name": "Rettangolo 105",
    width: 4.196,
    height: 4.196,
    transform: "matrix(0.94, -0.342, 0.342, 0.94, 8.214, 17.071)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_233",
    "data-name": "Rettangolo 233",
    width: 4.196,
    height: 4.196,
    transform: "matrix(0.94, -0.342, 0.342, 0.94, 10.576, 23.561)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_229",
    "data-name": "Rettangolo 229",
    width: 4.196,
    height: 4.196,
    transform: "matrix(0.94, -0.342, 0.342, 0.94, 4.371, 6.512)",
    fill: "#ed1c24",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_108",
    "data-name": "Rettangolo 108",
    width: 4.196,
    height: 4.196,
    transform: "matrix(0.94, -0.342, 0.342, 0.94, 22.166, 11.994)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_234",
    "data-name": "Rettangolo 234",
    width: 4.196,
    height: 4.196,
    transform: "matrix(0.94, -0.342, 0.342, 0.94, 24.528, 18.484)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_230",
    "data-name": "Rettangolo 230",
    width: 4.196,
    height: 4.196,
    transform: "matrix(0.94, -0.342, 0.342, 0.94, 18.322, 1.435)",
    fill: "#ed1c24",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_110",
    "data-name": "Rettangolo 110",
    width: 4.196,
    height: 4.196,
    transform: "matrix(0.94, -0.342, 0.342, 0.94, 15.188, 14.531)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_232",
    "data-name": "Rettangolo 232",
    width: 4.196,
    height: 4.196,
    transform: "matrix(0.94, -0.342, 0.342, 0.94, 17.551, 21.022)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1000",
    "data-name": "Tracciato 1000",
    d: "M0,3.1V1.81H1.821V0H3.114V1.81H4.957V3.1H3.114V4.935H1.821V3.1Z",
    transform: "translate(29.028 20.297) rotate(-20)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_224",
    "data-name": "Linea 224",
    y1: 10.148,
    x2: 27.882,
    transform: "translate(2.214 6.183)",
    fill: "none",
    stroke: "#272829",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionCalendarIcon);
export default __webpack_public_path__ + "static/media/action-calendar-icon.da38d7a589ba61cc46dd7581d2b129d8.svg";
export { ForwardRef as ReactComponent };